export default __webpack_public_path__ + "static/media/backtrackalgo_gif.97920446.gif";